/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/static-property-placement */
import React, { useEffect, useState } from 'react';
import { Comment } from '../../core/models/comment';
import CommentsApiService from '../../core/services/comments-api-service';
import { Severity, withSnackbar } from '../Snackbar/Snackbar';
import TinyEditableContent from '../TinyEditableContent/TinyEditableContent';

import './TinyComments.scss';

interface TinyCommentsProps {
  apiService: CommentsApiService;
  multiple: boolean;
  disabled: boolean;
  wordLimit: number;
  showSnackbar: (msg: string, sev?: Severity, dur?: number) => void;
}

function TinyComments({
  apiService,
  multiple = false,
  disabled = false,
  wordLimit = 1000,
  showSnackbar,
}: TinyCommentsProps): JSX.Element {
  const [comments, setComments] = useState<Comment[]>([]);

  useEffect(() => {
    async function fetchData() {
      const response = await apiService.getComments();
      setComments([...response]);
    }

    fetchData();
  }, [apiService]);

  const addNewComment = () => {
    const comment: Comment = {
      text: 'Add content here...',
    };

    apiService
      .addNewComment(comment)
      .then((res: Comment) => {
        showSnackbar('Comment was added with success');
        setComments((prevComments) => {
          return [...prevComments, { ...res, editMode: true, isNew: true }];
        });
      })
      .catch((error) => {
        console.error(error);
        showSnackbar('Failed to add comments', Severity.ERROR);
      });
  };

  const removeComment = (id: number) => {
    return apiService
      .deleteComment(id)
      .then(() => {
        showSnackbar('Removed with success');
        // eslint-disable-next-line react/no-access-state-in-setstate
        const currentComments = [...comments];
        const index = currentComments.findIndex((c) => c.id === id);
        currentComments.splice(index, 1);
        setComments(currentComments);
      })
      .catch((error) => {
        console.error(error);
        showSnackbar('Failed to delete comments', Severity.ERROR);
      });
  };

  const updateComment = (id: number, text?: string) => {
    return apiService
      .updateComment({
        id,
        text,
      })
      .then((res: Comment) => {
        showSnackbar('Saved with success');
        setComments((prevComments) => {
          return [...prevComments.map((comment: Comment) => ({ ...comment, isNew: false }))];
        });
        return res;
      })
      .catch((error) => {
        console.error(error);
        showSnackbar('Failed to update comments', Severity.ERROR);
      });
  };

  const addCommentBtn = (
    <button type="button" className="btn btn-secondary pdf-exclude" onClick={addNewComment}>
      Add content
    </button>
  );

  const richLimit = () => {
    return !multiple && comments.length > 0;
  };

  return (
    <div className="TinyComments">
      {comments.map(
        // eslint-disable-next-line react/no-unused-prop-types
        ({ id, text, editMode, isNew }: Comment) => {
          const newText = text || '';
          const commentId = id || 0;

          const save = updateComment.bind(null, commentId);

          return (
            <TinyEditableContent
              key={id}
              editMode={editMode}
              isNew={isNew}
              content={newText}
              disabled={disabled}
              wordLimit={wordLimit}
              remove={() => removeComment(commentId)}
              // eslint-disable-next-line react/jsx-no-bind
              save={save}
            />
          );
        }
      )}

      {!disabled && !richLimit() && addCommentBtn}
    </div>
  );
}

export default withSnackbar(TinyComments);
